<template>
	<v-main>
		<v-skeleton-loader
			v-if="loading"
			class="mx-auto"		
			type="article"
		></v-skeleton-loader>
		<div id="TalkMe-container" v-else style="position:fixed;top:48px;left:0;right:0;bottom:0"></div>
		
	</v-main>
</template>
<script>
//import axios from 'axios';
export default {
	name: "Support",    
	props:['props'],	
	data() {
		return {
			loading:true
		}
	},
	methods:{
		loadChat(d,w,m,i){
			w.supportAPIMethod = m;
			let s = d.createElement('script');
			s.id = 'supportScript'; 
			s.async = true;
			let id = '11c455dcd49d05bacfce0dacc783af11';
			s.src = (!i ? 'https://lcab.talk-me.ru/support/support.js' : 'https://static.site-chat.me/support/support.int.js') + '?h=' + id;
			s.onerror = i ? undefined : this.loadChat(d,w,m,true);
			s.onload = () => {            
				if (window.TalkMe) {					
					window.TalkMe("setClientInfo", {					
						phone:123 
					}, function(error) {
						if (error) {
							console.log("Ошибка setClientInfo", error);
						}
					});
				}
				console.log(s);
				console.log(this.loading);
				this.loading  = false;

			};
			w[m] = w[m] ? w[m] : function(){(w[m].q = w[m].q ? w[m].q : []).push(arguments);};
			(d.head ? d.head : d.body).appendChild(s);
		}
	},
	async mounted(){
		this.loadChat(document,window,'TalkMe');		
		/*window.ChatraID = 'Hd6CqBMkMkLaqjpro'
		let chatra = document.createElement('script');
		chatra.setAttribute('src', 'https://call.chatra.io/chatra.js');
		chatra.setAttribute('async', true);		
		document.head.appendChild(chatra);

		window.ChatraSetup = {
			mode: 'frame',
			injectTo: 'сhatra' 
		};
		window.ChatraIntegration = {		
			phone: this.props.user.phone,
			notes: 'ID:'+this.props.user.id+' \n'+'Долг:'+this.props.user.credit+' \n'+'Карт:'+this.props.user.cards,
		};		*/
	}	
}
</script>